export default __webpack_public_path__ + "static/media/contacts-reversed.e36c28dd.svg";